import { render, staticRenderFns } from "./PartnerStoreView.vue?vue&type=template&id=33123db3&scoped=true"
import script from "./PartnerStoreView.vue?vue&type=script&lang=ts"
export * from "./PartnerStoreView.vue?vue&type=script&lang=ts"
import style0 from "./PartnerStoreView.vue?vue&type=style&index=0&id=33123db3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33123db3",
  null
  
)

export default component.exports